import { useContentResource } from "@ctv/core";
import { TextSeo, ViewSeo } from "@ctv/shared-core/src";

import styles from "./Reason.module.css";

export default function Reason() {
  const cr = useContentResource().CorporateRevampFeaturesPage;

  return (
    <ViewSeo className={styles.container} justify="center" align="center">
      <TextSeo className={styles.text} variant="ui-large-bold">
        {cr.highlightText}
      </TextSeo>
    </ViewSeo>
  );
}
